import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import Icon from 'components/Icon';
import { Button } from 'components/Button';
import Model from '../../../../model';

import './index.sass';

const { block, el } = bem('certificate-teaser');

const CertificateTeaser = ({ cert: { image, price, quote }, scrollToFAQ }) => {

    const { openCertificateForm } = Model.modal;
    const openCertificateFormWithPrice = (price) => () => {
        openCertificateForm(price);
    }

    return (
        <div className={ block() }>
            <div className={ el('image') }>
                <img src={ image }/>
            </div>
            <div className={ el('content') }>
                <div className={el('top')}>
                    <div className={ el('header') }>
                        <div className={ el('title') }>
                            <Text serif>{ `Сертификат на ${ price } ₽` }</Text>
                        </div>
                        <div className={ el('instructions') } onClick={scrollToFAQ}>
                            <Icon name={ 'question' }/>
                            <Text>Инструкция по использованию</Text>
                        </div>
                    </div>
                    <div className={ el('quote') }>
                        <Text>{ quote }</Text>
                    </div>
                    <div className={ el('description') }>
                        <Text>Данный сертификат дает Вам возможность приобрести консультацию со специалистом проекта Otvet.
                            Сертификат на сумму { price } рублей не имеет ограничений по сроку.</Text>
                    </div>
                </div>
                <div className={ el('button') }>
                    <Button mod={ 'gold' }
                            onClick={ openCertificateFormWithPrice(price) }>
                        <Text>Купить</Text>
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default CertificateTeaser;
